import Vue from 'vue';
import VueRouter from 'vue-router';
import Welcome from "../components/Welcome.vue";
import SidebarLeftSettings from "../components/Sidebar/SidebarLeftSettings.vue";
import SidebarRightExport from "../components/Sidebar/SidebarRightExport.vue";
import Topbar from "../components/Topbar/Topbar.vue";
import JobCanvas from "../components/Content/JobCanvas.vue";
import StyleCanvas from "../components/Content/StyleCanvas.vue";
import SettingCanvas from "../components/Content/SettingCanvas.vue";
import SelectedImageCanvas from "../components/Content/SelectedImageCanvas.vue";
import MobileNavbar from "../components/Mobile/MobileNavbar.vue";
import MobileResult from "../components/Mobile/MobileResult.vue";
import MobileStyles from "../components/Mobile/MobileStyles.vue";
import MobileSettings from "../components/Mobile/MobileSettings.vue";
import MobilePromptEditor from '../components/Mobile/MobilePromptEditor.vue';
import MobileBackBtnSecondaryNav from "../components/Mobile/Elements/MobileBackBtnSecondaryNav";
import PromptEditorCanvas from '../components/Content/PromptEditorCanvas.vue';
import GenerateBtn from "../components/Settings/GenerateBtn";
import ExportBtn from "../components/Elements/ExportBtn";
import CreationHistory from "../components/Content/CreationHistory.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/:uuid/welcome',
        name: 'Welcome',
        components: {
            default: Welcome,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarLeftSettings,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: GenerateBtn
        },
    },
    {
        path: '/:uuid/canvas',
        name: 'JobCanvas',
        components: {
            default: JobCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: MobileResult,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: ExportBtn
        },
    },
    {
        path: '/:uuid/selected-image',
        name: 'SelectedImageCanvas',
        components: {
            default: SelectedImageCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SelectedImageCanvas,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/styles',
        name: 'StyleCanvas',
        components: {
            default: StyleCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: MobileStyles,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav
        },
    },
    {
        path: '/:uuid/history',
        name: 'CreationsHistory',
        components: {
            default: CreationHistory,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: CreationHistory,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav
        },
    },
    {
        path: '/:uuid',
        name: 'JobCanvasIndex',
        components: {
            default: JobCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: JobCanvas,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/settings',
        name: 'SettingCanvas',
        components: {
            default: SettingCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: MobileSettings,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav
        },
    },
    {
        path: '/:uuid/prompt_editor',
        name: 'PromptEditorCanvas',
        components: {
            default: PromptEditorCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: MobilePromptEditor,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav
        },
    },
];

const router = new VueRouter({
    mode: 'abstract',
    routes,
});

export default router;
